import { usePermissionCheck } from 'src/hooks/permission-check.hook';

import { IPermissionCheck } from './permission-check.interfaces';

const PermissionCheck = ({
  permission,
  children,
  action: actions,
  createdBy,
}: IPermissionCheck) => {
  const { checkRule } = usePermissionCheck(permission);

  return <>{checkRule(actions, accountId => accountId === createdBy) && children}</>;
};

export default PermissionCheck;
